// extracted by mini-css-extract-plugin
export default {"link":"deviceStatus_link__i8IXz","link-on":"deviceStatus_link-on__11c3J","link-off":"deviceStatus_link-off__uEZgJ"};